import { render, staticRenderFns } from "./DeliveryOrders.vue?vue&type=template&id=f75254a2&scoped=true"
import script from "./DeliveryOrders.vue?vue&type=script&lang=js"
export * from "./DeliveryOrders.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOrders.vue?vue&type=style&index=0&id=f75254a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75254a2",
  null
  
)

export default component.exports